import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const AdminPasswordVerification: React.FC = () => {
  const { verifyAdminPassword, authState } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const success = await verifyAdminPassword(password);
      setLoading(false);
      if (success) {
        navigate('/login');
      } else {
        setError('잘못된 비밀번호');
      }
    } catch (err) {
      setLoading(false);
      setError('비밀번호 검증 중 오류 발생');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: { xs: 1.5, sm: 3 },
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 4 },
          width: '100%',
          maxWidth: 450,
          boxSizing: 'border-box',
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          관제센터 접근
        </Typography>
        
        <Box>
          <Typography variant="subtitle1" align="center" color="text.secondary" sx={{ mb: 3 }}>
            관제센터 비밀번호를 입력
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="비밀번호"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              variant="outlined"
              autoComplete="current-password"
              disabled={loading}
            />
          
            {loading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <CircularProgress size={24} />
              </Box>
            )}
            
            {(error || authState.error) && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error || authState.error}
              </Alert>
            )}
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              확인
            </Button>
          </form>
        </Box>
      </Paper>
    </Box>
  );
};

export default AdminPasswordVerification; 